import VGrid from "@revolist/vue3-datagrid";

export default defineNuxtPlugin((nuxtApp) => {
    // nuxtApp.vueApp.use(VGrid);
    nuxtApp.vueApp.component('VGrid', VGrid);
});
